import styled from 'styled-components';
import { Check } from 'ui/lexus/outlines';

export default {
    Label: styled.label`
        display: flex;
        align-items: center;
    `,
    Text: styled.span`
        margin-top: -1px;
        font-family: NobelWGL,Helvetica,Arial,OpenSans,sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        color: #1A1A1A;
        text-align: left;
        letter-spacing: 0.267361px;
        
         @media(max-width: 600px){
            font-weight: 300;
            letter-spacing: 0.5px;
            color: #5B6164;
        }
    `,
    Link: styled.a`
        margin-top: -2px;
        font-family: NobelWGL,Helvetica,Arial,OpenSans,sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        color: #1A1A1A;
        cursor: pointer;
        text-decoration: none;
        letter-spacing: 0.267361px;
        padding-bottom: 2px;
        border-bottom: 1px solid #1A1A1A;
        
        @media(max-width: 600px){
            font-weight: 300;
            letter-spacing: 0.5px;
        }
    `,
    Input: styled.input.attrs({ className: 'checkbox-text' })`
        position: absolute;
        opacity: 0;
        cursor: pointer;
    `,
    InputMocked: styled.div.attrs({ className: 'input-mocked' })`
        width: 17px;
        min-width: 17px;
        height: 17px;
        border: 1px solid ${({ errorOnAgreenment }) => errorOnAgreenment ? '#B12A31' : '#1A1A1A'};
        box-sizing: border-box;
        background: #fff;
        background-image: ${props => props.checked ? `url(${Check})` : 'none'};
        background-repeat: no-repeat;
        background-position: center;
        transition: all .2s;
        margin-right: 15px;
        cursor: pointer;
    `,
    CheckboxError: styled.span.attrs({ className: 'checkbox-error' })`
        font-family: NobelWGL,Helvetica,Arial,OpenSans,sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 16px;
        letter-spacing: 0.267361px;
        color: #B12A31;
        display:block;
        text-align: left;
        margin-left: 35px;
        margin-bottom: 5px;
        @media (min-width: 700px) {
            margin-left: 0;
        }
    `,
};
